import React from "react";
import { Link } from "react-router-dom";
import styles from "./Layout.module.css";
import logo from "assets/images/stanbic_logo.svg";

function Layout({ children, activeLink }) {
  return (
    <div className={styles.layout}>
      <header>
        <div className={styles.logo}>
          <Link to="/">
            <img src={logo} alt="" />
          </Link>
        </div>
        <div className={styles.links}>
          {/* <Link
            className={activeLink === "listings" && styles.link_active}
            to="/property_listings"
          >
            View Listings
          </Link> */}
          <Link
            className={activeLink === "prequalification" && styles.link_active}
            to="/prequalification"
          >
            PreQualification
          </Link>
        </div>
      </header>
      <div className={styles.body}>{children}</div>
    </div>
  );
}

export default Layout;